import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7f654bb1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-2" }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "d-none d-sm-block" }
const _hoisted_5 = ["src"]
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src"]
const _hoisted_8 = ["src"]
const _hoisted_9 = ["src"]
const _hoisted_10 = ["src"]
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "section-btns" }
const _hoisted_13 = { class: "button-group" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-video" }, [
  /*#__PURE__*/_createElementVNode("iframe", {
    width: "100%",
    height: "100%",
    src: "https://www.youtube.com/embed/zvbjxZ58oC0",
    title: "YouTube video player",
    frameborder: "0",
    allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
    allowfullscreen: ""
  })
], -1))
const _hoisted_17 = { class: "section-2" }
const _hoisted_18 = ["src"]
const _hoisted_19 = /*#__PURE__*/_createStaticVNode("<h3 class=\"section-title\" data-v-7f654bb1><div data-v-7f654bb1><span class=\"strong\" data-v-7f654bb1>투명 음료 페트병</span>을 올바르게 분리배출한다면</div><div data-v-7f654bb1><span class=\"strong\" data-v-7f654bb1>소중한 자원</span>으로 다시 사용될 수 있어요.</div></h3><div class=\"section-desc\" data-v-7f654bb1><div class=\"desc-main\" data-v-7f654bb1> 지속가능한 환경을 위해 쓰레기 없는 세상을 꿈꾸는 <span class=\"strong\" data-v-7f654bb1>한국 코카-콜라</span>, <br data-v-7f654bb1> 내일을 위한 오늘의 습관을 하나하나씩 만들어가는 <span class=\"strong\" data-v-7f654bb1>이마트</span>, <br data-v-7f654bb1> 신선함을 지키는 선순환, ECO FRESH를 약속하고자 하는 <span class=\"strong\" data-v-7f654bb1>SSG.COM</span>, <br data-v-7f654bb1> 사람과 환경, 세상의 모든 가치를 연결하는 <span class=\"strong\" data-v-7f654bb1>G마켓</span>, <br data-v-7f654bb1> 자원 순환 경제 활성화에 앞장서는 <span class=\"strong\" data-v-7f654bb1>블랙야크</span>, <br data-v-7f654bb1> 전 세계적으로 플라스틱 문제 해결을 위해 노력하는 <span class=\"strong\" data-v-7f654bb1>WWF</span>가 <br data-v-7f654bb1> 투명 음료 페트병의 재활용률을 높이고 <br data-v-7f654bb1> 올바른 분리배출과 <br class=\"d-block d-sm-none\" data-v-7f654bb1> 자원순환의 중요성을 알리기 위해 만났습니다. <br data-v-7f654bb1><br data-v-7f654bb1> 분리배출 뿐 아니라 재활용 과정을 끝까지 투명하게 유지하고 <br data-v-7f654bb1> 모든 투명 음료 페트병이 잘 재활용 될 수 있도록 <br class=\"d-block d-sm-none\" data-v-7f654bb1> 글로벌 재활용 컨설팅 전문기업 <span class=\"strong\" data-v-7f654bb1>테라사이클</span>이 함께 합니다. </div><p class=\"desc-important\" data-v-7f654bb1> 자원 순환을 위한 우리들의 선한 영향력이 더 커질 수 있도록 함께 해요, <span class=\"strong\" data-v-7f654bb1>원더플 피플</span></p></div>", 2)

import { IProgram } from '@/types/program';
  import ApplyButton from '../apply-button/index-view.vue';

  export interface IProps {
    program: IProgram
  }

  
export default /*#__PURE__*/_defineComponent({
  props: {
    program: null
  },
  setup(__props: any) {

  


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      class: "bottle-1",
      src: require('./images/bottle.png')
    }, null, 8, _hoisted_2),
    _createElementVNode("img", {
      class: "bottle-2",
      src: require('./images/bottle.png')
    }, null, 8, _hoisted_3),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("img", {
        class: "bottle-3",
        src: require('./images/bottle.png')
      }, null, 8, _hoisted_5),
      _createElementVNode("img", {
        class: "bottle-4",
        src: require('./images/bottle.png')
      }, null, 8, _hoisted_6),
      _createElementVNode("img", {
        class: "bottle-5",
        src: require('./images/bottle.png')
      }, null, 8, _hoisted_7),
      _createElementVNode("img", {
        class: "bottle-6",
        src: require('./images/bottle.png')
      }, null, 8, _hoisted_8),
      _createElementVNode("img", {
        class: "bottle-7",
        src: require('./images/bottle.png')
      }, null, 8, _hoisted_9),
      _createElementVNode("img", {
        class: "bottle-8",
        src: require('./images/bottle.png')
      }, null, 8, _hoisted_10),
      _createElementVNode("img", {
        class: "bottle-9",
        src: require('./images/bottle.png')
      }, null, 8, _hoisted_11)
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createVNode(ApplyButton, { program: __props.program }, {
        default: _withCtx(({ apply, participate }) => [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", {
              class: "button",
              onClick: participate
            }, " 참여 신청 ", 8, _hoisted_14),
            _createElementVNode("div", {
              class: "button",
              onClick: apply
            }, " 수거 신청 ", 8, _hoisted_15)
          ])
        ]),
        _: 1
      }, 8, ["program"])
    ]),
    _hoisted_16,
    _createElementVNode("section", _hoisted_17, [
      _createElementVNode("img", {
        class: "icon",
        src: require('./images/icon.png')
      }, null, 8, _hoisted_18),
      _hoisted_19
    ])
  ]))
}
}

})